import {
  EConnectionStatus,
} from './rendering-engine-view.ts';

const connectionStatus: Record<EConnectionStatus, string> = {
  [EConnectionStatus.CONNECTING]: 'Connecting',
  [EConnectionStatus.CONNECTED]: 'Connected',
  [EConnectionStatus.WAITING_FOR_DATA]: 'Waiting for data',
  [EConnectionStatus.ERROR]: 'Error',
};

export default {
  connectionStatus,
  latestUpdate: 'Last update',
  enterFullscreen: 'Fullscreen',
  exitFullscreen: 'Exit fullscreen',
};
